/**
 * Combine multiple sort functions into one
 */
export const combineSorts =
  <T>(sorts: ((a: T, b: T) => number)[]): ((a: T, b: T) => number) =>
  (a, b) => {
    for (const sort of sorts) {
      const result = sort(a, b);

      if (result !== 0) {
        return result;
      }
    }

    return 0;
  };